import Vue from 'vue'
import Axios from 'axios'
import VueAxios from 'vue-axios'

const getCsrfToken = () => {
  const meta = document.querySelector('meta[name="csrf-token"]')
  return meta ? meta.getAttribute('content') : ''
}

const axiosInstance = Axios.create({
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-TOKEN': getCsrfToken(),
  },
})

Vue.use(VueAxios, axiosInstance)

export default axiosInstance
